var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-section-title',{attrs:{"title":"Clients"},scopedSlots:_vm._u([{key:"rightSide",fn:function(){return [_c('client-search')]},proxy:true}])}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }